import React from "react";
import dateformat from "dateformat";
import utils from "../lib/utils";
import TypeUtils from "../lib/TypeUtils";
import { Link } from "react-router-dom";

const fields = [
  { label: "ID", prop: "id" },
  { label: "Slug", prop: "slug" },
  { label: "Created On", prop: "date_created" },
  { label: "Last Updated", prop: "date_updated" }
];

const getUrl = model => {
  const section = TypeUtils.section(model);

  if (section === "content" && model.collection === undefined) {
    return utils.contentUrl("new");
  }

  return utils.siteUrl(section, "new");
};

const getDuplicateContent = model => {
  const { id, ...content } = model;
  return content;
};

export default ({ content }) => (
  <div>
    <div className="content-info">
      {fields.map((field, i) => {
        let value = content[field.prop];
        if (!value) return;

        if (field.prop.match(/date/)) {
          try {
            value = dateformat(new Date(value));
          } catch (e) {
            value = "";
          }
        }

        return (
          <div key={i}>
            <label>{field.label}</label>
            <span>{value}</span>
          </div>
        );
      })}
    </div>
    {!content.email && ( // dont allow duplicating users
      <div className="content-info-extra">
        <Link
          to={{
            pathname: getUrl(content),
            state: { fromModel: getDuplicateContent(content) }
          }}
          className="btn"
        >
          Duplicate
        </Link>
      </div>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./app/components/ContentInfo.js